var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.357,
    height: 15.357,
    viewBox: "0 0 15.357 15.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2614",
    "data-name": "Group 2614",
    transform: "translate(0 2.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2613",
    "data-name": "Group 2613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M10.969,85.333H1.645A1.645,1.645,0,0,0,0,86.978V96.3a1.645,1.645,0,0,0,1.645,1.645h9.324A1.645,1.645,0,0,0,12.615,96.3V86.978A1.645,1.645,0,0,0,10.969,85.333Z",
    transform: "translate(0 -85.333)",
    fill: "#8c8c8c"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2616",
    "data-name": "Group 2616",
    transform: "translate(2.194 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2615",
    "data-name": "Group 2615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M79.785,0H69.912a1.645,1.645,0,0,0-1.645,1.633v.013h8.775a2.746,2.746,0,0,1,2.742,2.742v8.775H79.8a1.645,1.645,0,0,0,1.633-1.645V1.645A1.645,1.645,0,0,0,79.785,0Z",
    transform: "translate(-68.267 0)",
    fill: "#8c8c8c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.2aabc4063e7f331a40288a5ec2de7b81.svg";
export { ForwardRef as ReactComponent };